module.exports = __webpack_public_path__ + "static/media/concello-pontevedra.b826cc90.svg";